import React, {Component} from 'react';
import './EmbedYouTubeVideo.css';

class EmbedYouTubeVideo extends Component {
  state = {  }

  renderLong = (myUrl) => {
    return (
      <div className="EmbedYouTubeVideo--container">
        <div className="EmbedYouTubeVideo--video">
        {/* <h1>Long</h1> */}
          {/* <iframe title="Real Time Touch" className="EmbedYouTubeVideo--iframe" width="100%" height="100%" src={myUrl} frameborder="0" allow="autoplay; encrypted-media" ></iframe> */}
        </div>
      </div>      
    )
  }

  render() {
    var myUrl = 'https://www.youtube.com/embed/'+ this.props.video + '?rel=0';

    // if(this.props.type==='long'){
    //   return this.renderLong(myUrl);
    // } else {
      return (
        <div className="EmbedYouTubeVideo--container">
           <div className="EmbedYouTubeVideo--video">
           {/* <h1>Short</h1> */}
              <iframe title="Real Time Touch" className="EmbedYouTubeVideo--iframe" width="100%" height="100%" src={myUrl} frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
           </div>
        </div>
      )
    // }


  }
}


 export default EmbedYouTubeVideo;


 // const EmbedYouTubeVideo = (props) => {
//    return (
//    <div className="EmbedYouTubeVideo--container">
//       <div className="EmbedYouTubeVideo--video">
//          <iframe className="EmbedYouTubeVideo--iframe" width="100%" height="100%" src="https://www.youtube.com/embed/vKLN7btr8m8?rel=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
//       </div>
//    </div>
//    )
//  }

// export default EmbedYouTubeVideo;



// WEBPACK FOOTER //
// ./src/common/EmbedYouTubeVideo/EmbedYouTubeVideo.js